import { Button } from '@/components/ui/Button';

/**
 * Bilah yang muncul begitu ada baris terceklist.
 *
 * Ditempel di atas daftar (sticky) supaya tetap terjangkau setelah menggulir
 * jauh ke bawah untuk memilih — kalau tidak, pengguna harus menggulir balik ke
 * atas hanya untuk menekan Hapus.
 */
export function SelectionBar({
  count,
  onClear,
  onDelete,
  label,
}: {
  count: number;
  onClear: () => void;
  onDelete: () => void;
  label: string;
}) {
  if (count === 0) return null;

  return (
    <div className="sticky top-0 z-10 flex flex-wrap items-center gap-3 border-b border-border bg-primary-soft px-4 py-3">
      <p className="text-sm font-medium text-ink">
        <span className="tabular">{count}</span> {label} dipilih
      </p>
      <div className="ml-auto flex gap-2">
        <Button size="sm" variant="ghost" onClick={onClear}>
          Batalkan pilihan
        </Button>
        <Button size="sm" variant="danger" onClick={onDelete}>
          Hapus Data
        </Button>
      </div>
    </div>
  );
}
